/**
 * DO NOT directly reference process.env.NEXT_PUBLIC_ENVIRONMENT;
 * use getAppEnvironmentAtRuntime() instead.
 *
 * It is to avoid NextJS to statically replace the environment variable
 * at build time.
 */
const ENVIRONMENT_ENV_KEY = 'NEXT_PUBLIC_ENVIRONMENT'

export function getAppEnvironmentAtRuntime(): string {
  return process.env.APP_ENVIRONMENT ?? process.env[ENVIRONMENT_ENV_KEY] ?? 'no-env'
}

export function isProd(): boolean {
  return /-prd$/.test(getAppEnvironmentAtRuntime())
}
